import React, { useEffect, useState } from "react";
import {
  Airplay,
  ChevronLeft,
  Eye,
  Feather,
  Menu,
  Play,
  Target,
} from "react-feather";
import { Link, useLocation } from "react-router-dom";
import { getAllVendors } from "../Service/VendorService";
import { getAllVehicles } from "../Service/VehicleService";
import {
  getBillProcessByDate,
  saveBillProcessBulk,
} from "../Service/BillProcessService";
import { useToast } from "../Components/toast/ToastProvider";
import "../Style/home.css";
import Sidebar from "./Sidebar";
import Footer from "../Components/Footer";

const BillProcessPage = ({ handleLogout }) => {
  const [showSideBar, setShowSideBar] = useState(false);
  const [processDate, setProcessDate] = useState("");
  const [rows, setrows] = useState([]);
  const toast = useToast();
  const [vendors, setVendors] = useState([]);
  const [vehicles, setVehicles] = useState([]);
  const location = useLocation();
  const currentPath = location.pathname;

  useEffect(() => {
    fetchDropdowns();
  }, []);

  const fetchDropdowns = async () => {
    try {
      const [venRes, vehRes] = await Promise.all([
        getAllVendors(),
        getAllVehicles(),
      ]);
      setVendors(venRes?.data || []);
      setVehicles(vehRes?.data || []);
    } catch (err) {
      toast(err.message || "Failed to fetch data", "ERROR");
    }
  };

  const fetchBills = async (date) => {
    if (!date) {
      setrows([]);
      return;
    }

    try {
      const res = await getBillProcessByDate(date);
      const allBills = res.bills || [];

      const newBills = allBills?.filter((b) => b.status === "new");

      if (newBills.length == 0) {
        setrows([]);
        toast("No bills available for processing", "ERROR");
        return;
      }
      const formatted = newBills.map((b) => {
        const normalList = res.normal_advances.filter(
          (a) => a.vendor_id === b.vendor_id
        );

        const receiptList = res.receipt_advances.filter(
          (a) => a.vendor_id === b.vendor_id
        );

        return {
          bill_id: b.bill_id,
          vendor_id: b.vendor_id,
          vehicle_id: b.vehicle_id,
          trip_count: b.trip_count,
          total_amount: b.total_amount,

          normal_advances: normalList,
          nor_advance_id: normalList.length === 1 ? normalList[0].id : null,
          nor_advance: normalList.length === 1 ? normalList[0].amount : 0,
          nor_advance_deduction: b.nor_advance_deduction || 0,

          receipt_advances: receiptList,
          res_advance_id: receiptList.length === 1 ? receiptList[0].id : null,
          res_advance: receiptList.length === 1 ? receiptList[0].amount : 0,
          res_advance_deduction: b.res_advance_deduction || 0,
        };
      });

      setrows(formatted);
    } catch (err) {
      toast(err.message || "Failed to fetch Bill", "ERROR");
    }
  };

  const handlesave = async () => {
    if (!rows || rows.length === 0) {
      return;
    }

    const isValidRow = (row) => {
      const total = Number(row.total_amount || 0);
      const norDed = Number(row.nor_advance_deduction || 0);
      const resDed = Number(row.res_advance_deduction || 0);

      const payable = total - (norDed + resDed);

      if (payable < 0) {
        return {
          valid: false,
          msg: "Payable amount cannot be negative",
        };
      }

      return { valid: true };
    };

    for (let r of rows) {
      const check = isValidRow(r);

      if (!check.valid) {
        toast(check.msg, "ERROR");
        return;
      }
    }

    const payload = {
      items: rows.map((r) => ({
        bill_id: r.bill_id,
        nor_advance_deduction: Number(r.nor_advance_deduction || ""),
        nor_advance_id:
          Number(r.nor_advance_deduction || 0) > 0 ? r.nor_advance_id : 0,
        res_advance_deduction: Number(r.res_advance_deduction || ""),
        res_advance_id:
          Number(r.res_advance_deduction || 0) > 0 ? r.res_advance_id : 0,
      })),
    };
    try {
      await saveBillProcessBulk(payload);
      setTimeout(() => {
        toast("Process Saved successfully", "SUCCESS");
      }, 1000);
      setrows([]);
      setProcessDate("");
    } catch (err) {
      toast(err.message || "Save Failed");
    }
  };
  return (
    <div className="fixed-bottom-bar" style={{ backgroundColor: " #F0F8FF" }}>
      <div className="osahan-trending">
        {/* Header */}
        <div className="bg-primary border-bottom p-3">
          <div className=" d-flex align-items-center justify-content-between">
            <Link to="/" className="text-white font-weight-bold">
              <ChevronLeft /> Back
            </Link>
            <Link className="toggle">
              <span
                className="toggle"
                onClick={() => setShowSideBar(true)}
                style={{ cursor: "pointer" }}
              >
                <Menu size={30} color="white" />
              </span>
            </Link>
          </div>
          <h2 className="font-weight-bold pt-3 m-0 text-white">Bill Process</h2>
        </div>

        <div className="p-3">
          <input
            type="date"
            value={processDate}
            className="form-control"
            onChange={(e) => {
              const value = e.target.value;
              setProcessDate(value);
              fetchBills(value);
            }}
          />
        </div>

        {/* Trending Cards */}
        <div className="most_popular p-3">
          <div className="row justify-content-center">
            {rows.map((row, index) => {
              const vendor = vendors.find((v) => v.id === row.vendor_id);
              const vehicle = vehicles.find((v) => v.id === row.vehicle_id);

              return (
                <div
                  className="col-12 d-flex justify-content-center mb-3"
                  key={index}
                >
                  <div className="card bill-card">
                    <div className="card-body mt-3">
                      {/* HEADER */}
                      <div className="d-flex justify-content-between mb-2">
                        <h6
                          className="mb-0 vendor-title"
                          style={{ textTransform: "capitalize" }}
                        >
                          {vendor?.name}
                        </h6>
                      </div>

                      <p className="text-muted mb-1 meta-text">
                        Vehicle: {vehicle?.vehicle_number}
                      </p>
                      <p className="mb-1 meta-text">
                        Trips: <b>{row.trip_count}</b>
                      </p>
                      <p className="mb-2 total-amount">
                        Total: <b>₹ {row.total_amount.toFixed(2)}</b>
                      </p>

                      <hr />

                      {/* NORMAL ADVANCE */}
                      <div className="mb-5 font-para">
                        <small>Normal Advance</small>
                        <div>₹ {row.nor_advance.toFixed(2)}</div>
                        <div className="mb-3 mt-4 floating-input">
                          <input
                            type="text"
                            className="form-control floating-field"
                            placeholder=" "
                            disabled={!row.nor_advance || row.nor_advance <= 0}
                            onChange={(e) => {
                              const value = e.target.value;
                              setrows((prev) =>
                                prev.map((r, i) =>
                                  i === index
                                    ? { ...r, nor_advance_deduction: value }
                                    : r
                                )
                              );
                            }}
                            required
                          />
                          <label>Normal Deduction</label>
                        </div>
                      </div>

                      {/* RECEIPT ADVANCE */}
                      <div className="mb-2">
                        <small>Receipt Advance</small>
                        <div>₹ {row.res_advance.toFixed(2)}</div>
                        <div className="mb-3 mt-4 floating-input">
                          <input
                            type="tex"
                            className="form-control floating-field"
                            placeholder=" "
                            disabled={!row.res_advance || row.res_advance <= 0}
                            onChange={(e) => {
                              const value = e.target.value;
                              setrows((prev) =>
                                prev.map((r, i) =>
                                  i === index
                                    ? { ...r, res_advance_deduction: value }
                                    : r
                                )
                              );
                            }}
                            required
                          />
                          <label>Receipt Deduction</label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
          {rows.length > 0 && (
            <div className="d-flex justify-content-center mt-4 mb-5">
              <button
                className="btn btn-success px-5 py-2"
                onClick={handlesave}
              >
                Save Bills
              </button>
            </div>
          )}
        </div>

        {/* Sidebar */}
        <Sidebar
          showSideBar={showSideBar}
          setShowSideBar={setShowSideBar}
          onLogout={handleLogout}
        />

        {/* Footer */}
          <Footer />
      </div>
    </div>
  );
};

export default BillProcessPage;
